/** Presence dot colours, shared so the web and native dots cannot drift. Fixed hues: status colours read the same in both themes. */
export const PRESENCE_DOT_COLOURS = {
  available: '#22c55e',
  busy: '#ef4444',
  amber: '#f59e0b',
  onSite: '#3b82f6',
  offlineFill: '#e2e8f0',
  offlineStroke: '#94a3b8',
  bar: '#ffffff',
} as const;
